function ajaxRecentPosts() {
  const $section = $('.js-recent-posts');

  if ($section.length == 0) {
    return
  }

  const $container = $('.js-items');

  $container.on('click' , '.paging a', function(event) {
    event.preventDefault();

    $.ajax({
      url: this.href,
    })
    .done(response => {
      handleNewPosts(response, $container);
    })
    .fail(function() {
      console.log("Something went wrong while fetching recent posts..");
    })
  });
}

function handleNewPosts(response, $container) {
  const $posts = $(response).find('.js-items').html();
  $container.html($posts)

  setTimeout(() => {
    window.scrollTo(0, window.scrollY - 1)
    window.scrollTo(0, window.scrollY + 1)
  }, 100)
}

ajaxRecentPosts();